var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"i-generate-image",attrs:{"src":_vm.generateImage,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }